<template>
	<div id="uVideo">
		<Row :gutter="20" v-if="ucVideoList.length!=0">
			<Col span="8" v-for="(item,i) in ucVideoList">
			<Card :bordered="false" class="uc_card" :to="{name:'player',query:{courseId:item.courseId}}">
				<img :src="photoUrl +item.photo" style="width: 100%;height: 160.5px;" />
				<div class="uc_cardTitle">
					<p>{{item.name}}</p>
					<span>{{item.dept.name}} / {{item.type.name}}</span>
					<div v-if="isLive">距离开始还有：<cTime :endTime='item.startTime'></cTime>
					</div>
				</div>
			</Card>
			</Col>
		</Row>
		<div class="uVideoNull" v-else>
			<img src="../../assets/icons/nothing.png" />
			<p v-if="isLive">暂无预约直播</p>
			<p v-else>暂无收藏视频</p>
			<Button type="primary" ghost to="/">返回首页</Button>
		</div>
	</div>
</template>

<script>
	import cTime from '../tools/countTime.vue';
	export default {
		name: 'uVList',
		props: ['ucVideoList', 'isLive'],
		components: {
			cTime
		},
		data() {
			return {
				photoUrl: $yykConfig.fileUrl
			}
		},
		methods: {

		},
	}
</script>

<style>
	.uc_card {
		margin-bottom: 20px;
		color: #264653;
	}

	.uc_cardTitle {
		padding: 10px;
	}

	.uc_cardTitle p {
		line-height: 24px;
		height: 30px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.uVideoNull {
		text-align: center;
		width: 300px;
		margin: 100px auto;
	}

	.uVideoNull img {
		width: 100%;
	}

	.uVideoNull p {
		line-height: 40px;
	}
</style>
